export const isRequired = value => (value ? undefined : 'Required')

export const isRequiredWhen = when => (value, values) =>
    when(values) ? isRequired(value) : undefined



// WEBPACK FOOTER //
// ./src/utils/form/validators.js